const API_URL = window.location.host.includes('localhost') ? 'http://localhost:3001' : 'https://enigmatic-shelf-39065.herokuapp.com';
import { getIdeas } from './ideas';
import { getPosts } from './posts';

const fetchDataOnSuccess = payload => {
    switch(payload.type) {
        case 'idea':
            return getIdeas();
        case 'post':
            return getPosts();
        default:
            return { type: 'ERROR_FETCHING_DATA_AFTER_COMMENT' };
    }
};

export const postComment = data => ({
    type: 'INITIATED_POST_COMMENT',
    payload: { type: data.type },
    meta: {
        fetch: {
            url: `${API_URL}/api/comments`,
            settings: {
                method: 'POST',
                headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
                body: JSON.stringify(data),
            },
            actions: {
                success: fetchDataOnSuccess,
                error: 'POST_COMMENTS_ERROR',
            },
        },
    },
});

export const deleteComment = data => ({
    type: 'INITIATED_DELETE_COMMENT',
    payload: { type: data.type },
    meta: {
        fetch: {
            url: `${API_URL}/api/comments/${data.commentId}`,
            settings: {
                method: 'DELETE',
                headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
                body: JSON.stringify({
                    type: data.type,
                    contentId: data.contentId,
                }),
            },
            actions: {
                success: fetchDataOnSuccess,
                error: 'DELETE_COMMENTS_ERROR',
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/actions/general.js